export class AuthApiService {
  constructor(http) {
    this.endpoint = '/auth';
    this.http = http;
  }

  async getUserConfig() {
    const { data } = await this.http.get(this.endpoint + '/me/');
   /* data.profile.avatar =
      process.env.NODE_ENV === 'production'
        ? data.profile.avatar
        : data.profile.avatar
        ? process.env.VUE_APP_API_URL + '/' + data.profile.avatar
        : data.profile.avatar; */
    return data;
  }
  /**
   * @param {Object} params - Register subject
   * @param {string} params.username - Email
   * @param {string} params.password
   * @param {string} params.first_name
   * @param {string} params.middle_name
   * @param {string} params.last_name
   */
  async register(params) {
    const { data } = await this.http.post(this.endpoint + '/register/', params);
    return data;
  }
  /**
   * @param {Object} params
   * @param {string} params.current_password
   * @param {string} params.new_password
   * @param {string} params.new_password_confirmation
   */
  async reset(params) {
    const { data } = await this.http.post('/change-password/', params);
    return data;
  }
}
